import { render, staticRenderFns } from "./TabGroup.vue?vue&type=template&id=b61a4ace&scoped=true&"
import script from "./TabGroup.vue?vue&type=script&lang=js&"
export * from "./TabGroup.vue?vue&type=script&lang=js&"
import style0 from "./TabGroup.vue?vue&type=style&index=0&id=b61a4ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61a4ace",
  null
  
)

export default component.exports